import { render, staticRenderFns } from "./ClientDriverInputBox.vue?vue&type=template&id=589dd637"
import script from "./ClientDriverInputBox.vue?vue&type=script&lang=js"
export * from "./ClientDriverInputBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports